var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adult-avatar"},[_c('div',{staticClass:"avatar",on:{"click":_vm.onCheck}},[_c('img',{attrs:{"src":_vm.user.avatar}})]),_c('div',{staticClass:"instruction"},[_vm._v("我")]),(_vm.user && _vm.user.vspFaceStatus !== 1)?_c('div',{staticClass:"warning"},[_vm._v("点击头像"),_c('br'),_vm._v("进行人脸核验")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }